import { Button, Box, useTheme } from "@mui/material";
import React, { useState } from "react";
import { tokens } from "../../theme";
import ToggleButtons from "../../components/ToggleButtons";
import PesapalPackageCard from "./PesapalPackageCard";

function PesapalPayment() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Pesapal pricing is USD-only and fixed.
  const currency = "USD";
  const [billingCycle, setBillingCycle] = useState("monthly");
  const PRO_USD_MONTHLY = 17;
  const PRO_USD_YEARLY = 170;
  const CORPORATE_USD_MONTHLY = 45;
  const CORPORATE_USD_YEARLY = 450;

  const toggleButtons = [
    { value: "monthly", text: "Monthly" },
    { value: "yearly", text: "Yearly (2 Months Free)" },
  ];

  const handleBillingCycleChange = (event, value) => {
    if (!value) return;
    setBillingCycle(value);
  };

  const proPrice = billingCycle === "yearly" ? PRO_USD_YEARLY : PRO_USD_MONTHLY;
  const corporatePrice =
    billingCycle === "yearly" ? CORPORATE_USD_YEARLY : CORPORATE_USD_MONTHLY;
  const perPeriodLabel = billingCycle === "yearly" ? " /year" : " /month";

  const litePoints = [
    "Unlimited Borrowers",
    "Unlimited Loans",
    "Unlimited Loan Statements",
  ];

  const proPoints = [
    "1 User",
    "Unlimited Borrowers",
    "Unlimited Loans",
    "Unlimited Loan Statements",
  ];

  const corporatePoints = [
    "All features of PRO",
    "5 Users",
    "Set User Access Levels",
    "Priority Support",
  ];

  return (
    <Box maxWidth={"100%"}>
      <Box sx={{ justifyContent: "center", display: "flex" }}>
        <h1>LoanTabs Subscription Packages</h1>
      </Box>
      <Box
        display="flex"
        justifyContent={"center"}
        mb="10px"
        alignItems={"center"}
      >
        <ToggleButtons
          buttons={toggleButtons}
          handleChange={handleBillingCycleChange}
          value={billingCycle}
        />
      </Box>
      <Box
        gap="30px"
        m="20px"
        sx={{
          flexWrap: "wrap",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PesapalPackageCard
          cardTitle={"Lite"}
          price={"Free"}
          perMonth={""}
          intro={"Free 30 Days Trial for New Users"}
          bullets={litePoints}
          backgroundColor={"pink"}
        />
        <PesapalPackageCard
          buttonText={"BUY PRO"}
          buttonColor={"black"}
          paymentAmount={proPrice}
          cardTitle={"PRO"}
          currency={currency}
          price={proPrice}
          perMonth={perPeriodLabel}
          intro="For Small Money Lenders"
          bullets={proPoints}
          backgroundColor={colors.greenAccent[300]}
          billingCycle={billingCycle}
        />
        <PesapalPackageCard
          cardTitle="CORPORATE"
          currency={currency}
          price={corporatePrice}
          perMonth={perPeriodLabel}
          paymentAmount={corporatePrice}
          intro="For Mid-Sized Lenders & Microfinances"
          bullets={corporatePoints}
          backgroundColor="yellow"
          buttonText={"BUY CORPORATE"}
          billingCycle={billingCycle}
        />
      </Box>
      <Box
        sx={{ alignItems: "center", display: "flex", flexDirection: "column" }}
      >
        <h1>Have an inquiry? </h1>
        <Button
          onClick={() =>
            window.open("https://www.loantabs.com/support", "_blank")
          }
          color="success"
          variant="contained"
          sx={{ mb: "20px" }}
        >
          CONTACT US
        </Button>
      </Box>
    </Box>
  );
}

export default PesapalPayment;
